import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import { Provider } from "react-redux";
import { store } from "./app/store.js";
import { Analytics } from "@vercel/analytics/react";

// Initialize Sentry
Sentry.init({
  dsn: "https://d020c5e8a21ee307e3a04fcff674d3a6@o4510381872054272.ingest.us.sentry.io/4510657561690112",
  
  // Tunnel Sentry requests through our own domain to bypass ad blockers
  tunnel: "/m-api",
  
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  
  // Performance monitoring - capture 100% of transactions
  tracesSampleRate: 1.0,
  
  // Session replay settings
  replaysSessionSampleRate: 1.0, // 100% of sessions
  replaysOnErrorSampleRate: 1.0, // 100% when error occurs
  
  // Send user PII (IP address, etc.)
  sendDefaultPii: true,
});

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>}>
      <Provider store={store}>
        <App />
        {/* Proxy analytics through /v-api to bypass ad blockers */}
        <Analytics scriptSrc="/v-api/script.js" endpoint="/v-api" />
      </Provider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
